import { Component } from '@angular/core';

@Component({
  selector: 'app-voting',
  templateUrl: './voting.component.html',
  styleUrls: ['./voting.component.css']
})
export class VotingComponent {   
  showCompletedTokens: boolean = true;
  showActiveTokens: boolean = true; // Controls the view toggle
  activeFAQ: number | null = null;

  toggleFAQ(index: number) {
    this.activeFAQ = this.activeFAQ === index ? null : index;
  }
  popUp=false;

openPopUp() {
this.popUp=true;
}
closePopup() {
this.popUp=false;
}


activeTokens = [
  {
    name: 'DGTEK',
    symbol: 'USDG',
    image: 'https://inytesconnedwipdvfs.koinpark.com/ipfs/QmPwSg8HuQvyg3Smf33DzDBJvCs3RoWPAvGMiqoLsyEZRB',
    description: 'The live price of DGTEK as of February 3 is $1.95, with a 24-hour trading volume of $1.35M and a market cap of $3.89B.',
    totalSupply: '10,000,000,000 USDG',
    startDate: '2025-02-03 15:30:00',
    endDate: '2025-03-03 17:00:00',
    votes: 127
  }
];

completedTokens = [
  {
    name: 'Completed Token 1',
    symbol: 'CMP1',
    image: 'https://example.com/completed-token1.png',
    description: 'This token has completed its sale phase and is no longer available for trading.',
    totalSupply: '5,000,000 CMP1',
    startDate: '2024-12-01 12:00:00',
    endDate: '2025-01-01 12:00:00',
    votes: 85
  }
];


}
